// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","355":"e3f3c168","455":"a839625a","977":"1ff7fdd1"}[chunkId] + ".chunk.js";
};